import React from 'react'
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome'

export default function Icon(props: FontAwesomeIconProps) {
  return <FontAwesomeIcon {...props} />
}
